module.exports = __webpack_public_path__ + "img/2_3.fe1c8065.jpg";